import "../styles/general.css";

import Footer from "../components/footer/Footer";
import Header from "../components/header/Header";
import globalContext from "../Contexts/GlobalContext";
import BlueLoader from "../components/loader/BlueLoader";
import DesktopView from "../components/desktopview/DesktopView";
import CarDetailsBox from "../components/cardetailsbox/CarDetailsBox";
import ChangeKmModal from "../components/changeKmModal/ChangeKmModal";

import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import React, { useContext, useEffect, useRef, useState } from "react";
// import { sigments } from "../constants/sigments";
import { SHOW_PIECES } from "../constants/piecesIcon";
import {
  SIGMENT_BOX_LEFT_BLUE,
  SIGMENT_BOX_LEFT_YELLOW,
  SIGMENT_BOX_RIGHT_BLUE,
  SIGMENT_BOX_RIGHT_YELLOW,
} from "../constants/sigmentsBox";
import { sigments } from "../constants/sigments";
import { PIECES_TITLE } from "../constants/pieces";

export default function LongTerms() {
  const navigate = useNavigate();

  /// ref passes start  ///
  const contextData = useContext(globalContext);
  /// ref passes end ///
  const headerRef = useRef();
  const footerRef = useRef();

  const bodyRef = useRef();

  // ----->
  const [cookies, setCookies, removeCookies] = useCookies([]);
  // ----->

  /// 8 box precentage section start ///
  const [suspensionPercent, setSuspensionPercent] = useState(0);
  const [collagePercent, setCollagePercent] = useState(0);
  const [catalystPercent, setCatalystPercent] = useState(0);
  const [beltPercent, setBeltPercent] = useState(0);
  const [coolerPercent, setCoolerPercent] = useState(0);
  const [detailingPercent, setDetailingPercent] = useState(0);
  const [picklingPercent, setPicklingPercent] = useState(0);
  const [lightingPercent, setLightingPercent] = useState(0);
  /// 8 box precentage section end ///

  /// useeffect for percents start ///
  useEffect(() => {
    setSuspensionPercent(
      Number(cookies["suspension"]) ? Number(cookies["suspension"]) : 0
    );
    setCollagePercent(
      Number(cookies["collage"]) ? Number(cookies["collage"]) : 0
    );
    setCatalystPercent(
      Number(cookies["catalyst"]) ? Number(cookies["catalyst"]) : 0
    );
    setBeltPercent(
      Number(cookies["engine-straps"]) ? Number(cookies["engine-straps"]) : 0
    );
    setLightingPercent(Number(cookies["lamp"]) ? Number(cookies["lamp"]) : 0);
    setCoolerPercent(Number(cookies["cooler"]) ? Number(cookies["cooler"]) : 0);
    setPicklingPercent(
      Number(cookies["wrenching"]) ? Number(cookies["wrenching"]) : 0
    );
    setDetailingPercent(
      Number(cookies["detailing"]) ? Number(cookies["detailing"]) : 0
    );
  }, []);
  /// useeffect for percents end ///

  //// mt alireza start ////
  const titleRef = useRef();
  const pb = useRef();

  //// useeffect for history control start ////

  //// useeffect for history control end ////
  const [suspensionPercent2, setSuspensionPercent2] = useState(0);
  const [collagePercent2, setCollagePercent2] = useState(0);
  const [catalystPercent2, setCatalystPercent2] = useState(0);
  const [beltPercent2, setBeltPercent2] = useState(0);
  const [coolerPercent2, setCoolerPercent2] = useState(0);
  const [detailingPercent2, setDetailingPercent2] = useState(0);
  const [picklingPercent2, setPicklingPercent2] = useState(0);
  const [lightingPercent2, setLightingPercent2] = useState(0);
  ////----->
  const [loadApiEnd, setLoadApiEnd] = useState(false);
  const [loadSpedoEnd, setLoadSpedoEnd] = useState(false);
  setTimeout(() => {
    setLoadApiEnd(true);
  }, 500);
  const [loadType_1, setLoadType_1] = useState(true);
  const [loadType_2, setLoadType_2] = useState(true);
  const [loadType_3, setLoadType_3] = useState(true);
  const [loadType_4, setLoadType_4] = useState(true);
  const [loadType_5, setLoadType_5] = useState(true);
  const [loadType_6, setLoadType_6] = useState(true);
  const [loadType_7, setLoadType_7] = useState(true);
  const [loadType_8, setLoadType_8] = useState(true);
  useEffect(() => {
    if (loadApiEnd) {
      TIMERANIM(
        setSuspensionPercent2,
        suspensionPercent2,
        suspensionPercent,
        loadType_1,
        setLoadType_1
      );
      TIMERANIM(
        setCollagePercent2,
        collagePercent2,
        collagePercent,
        loadType_2,
        setLoadType_2
      );
      TIMERANIM(
        setCatalystPercent2,
        catalystPercent2,
        catalystPercent,
        loadType_3,
        setLoadType_3
      );
      TIMERANIM(
        setBeltPercent2,
        beltPercent2,
        beltPercent,
        loadType_4,
        setLoadType_4
      );
      TIMERANIM(
        setCoolerPercent2,
        coolerPercent2,
        coolerPercent,
        loadType_5,
        setLoadType_5
      );
      TIMERANIM(
        setDetailingPercent2,
        detailingPercent2,
        detailingPercent,
        loadType_6,
        setLoadType_6
      );
      TIMERANIM(
        setPicklingPercent2,
        picklingPercent2,
        picklingPercent,
        loadType_7,
        setLoadType_7
      );
      TIMERANIM(
        setLightingPercent2,
        lightingPercent2,
        lightingPercent,
        loadType_8,
        setLoadType_8
      );
    }
  }, [
    suspensionPercent2,
    collagePercent2,
    catalystPercent2,
    beltPercent2,
    coolerPercent2,
    detailingPercent2,
    picklingPercent2,
    lightingPercent2,
    loadApiEnd,
  ]);

  function TIMERANIM(Valiable, Count, CountMemory, bol, setBol) {
    let i = 8;
    let timer = 10;
    if (Count > 50 && bol) {
      timer += Count / 4;
    } else if (!bol) {
      i = 4;
      timer = 50;
    }
    function SET(Number) {
      Valiable(Number);
    }
    setTimeout(() => {
      if (bol) {
        if (Count + i < 100) {
          SET(Count + i);
        } else {
          SET(100);
          setBol(false);
        }
      }
      if (!bol) {
        if (Count - i > CountMemory) {
          SET(Count - i);
        } else {
          SET(CountMemory);
        }
      }
    }, timer);
  }

  return (
    <>
      <div className="hidden min-[1024px]:block">
        <DesktopView />
      </div>
      <div className="w-full overflow-auto min-[1024px]:hidden">
        <img
          src="../assets/images/body/body-bgimg.png"
          alt=""
          className="absolute w-full h-full top-0  right-0 -z-50"
        />

        <Header forwardRef={headerRef} />
        {contextData?.changeKmModalIsOpen && <ChangeKmModal />}
        <div
          ref={bodyRef}
          className="w-full mt-[1.8vw] flex flex-col justify-evenly"
        >
          <CarDetailsBox forwardRef={titleRef} />
          <div className="absolute flex flex-col top-[36.5vw] bottom-[21vw] justify-between right-0 left-0 overflow-auto my-[3.7vw]">
            <div
              ref={pb}
              className="flex items-center justify-between px-[3.773495908115375vw] pb-[0.5vw]"
            >
              {/* /// collage section start /// */}
              <div
                className="relative animFadeIn"
                onClick={(e) => {
                  navigate(`/piece-details/${collagePercent}_collage`);
                }}
              >
                <span
                  className={`absolute ${
                    !loadType_2 && collagePercent2 <= 10
                      ? "text-color-primary-B"
                      : "text-color-primary-D"
                  } font-font_primary_A text-[2.8vw] top-[3.7vw] right-[3.8vw]`}
                >
                  {PIECES_TITLE["collage"]}
                </span>
                <div
                  className={`absolute w-[7.2vw] h-[0.9vw]  top-[12.8vw] right-[3.2vw] outline-none rounded-[1.8vw]  ${
                    loadType_2
                      ? "bg-color-primary-D"
                      : collagePercent2 <= 10
                      ? `${loadType_2 ? "" : "animAlarm"}`
                      : "bg-color-primary-D"
                  } `}
                ></div>
                {!loadType_2 && collagePercent2 <= 10 ? (
                  <div className="absolute top-[15.5vw] right-0">
                    {SHOW_PIECES("collage", "#FEC42B")}
                  </div>
                ) : (
                  <div className="absolute top-[15.5vw] right-0">
                    {SHOW_PIECES("collage", "#00FFF2")}
                  </div>
                )}

                <div className="w-[44.95648687530954vw] h-[30.42616919412278vw]">
                  {!loadType_2 && collagePercent2 <= 10
                    ? SIGMENT_BOX_RIGHT_YELLOW
                    : SIGMENT_BOX_RIGHT_BLUE}
                </div>

                {!loadApiEnd && <BlueLoader width={10} top={33.5} left={23} />}

                <div
                  className={`absolute top-0 left-0 W-[30.42381075918021vw] h-[30.42381075918021vw]  ${
                    !loadApiEnd ? "hidden" : ""
                  }`}
                >
                  {sigments(collagePercent2)}
                </div>

                <div
                  className={`absolute w-[18.16329507799378vw] h-[18.16329507799378vw]  top-[20.5%] right-[46%] flex items-center justify-center rounded-full ${
                    !loadApiEnd ? "hidden" : ""
                  }`}
                >
                  <span
                    className={` text-[7.546991816230749vw] ${
                      collagePercent2 <= 10
                        ? "text-color-primary-B"
                        : "text-color-primary-D"
                    } font-font_primary_D `}
                  >
                    {collagePercent2 < 10
                      ? `0${collagePercent2}`
                      : `${collagePercent2}`}
                  </span>
                </div>
              </div>
              {/* /// collage section end /// */}

              {/* /// suspension  section start /// */}
              <div
                className="relative animFadeIn"
                onClick={(e) => {
                  navigate(`/piece-details/${suspensionPercent}_suspension`);
                }}
              >
                <span
                  className={`absolute ${
                    !loadType_1 && suspensionPercent2 <= 10
                      ? "text-color-primary-B"
                      : "text-color-primary-D"
                  } font-font_primary_A text-[2.8vw] top-[3.5vw] left-[5vw]`}
                >
                  {PIECES_TITLE["suspension"]}
                </span>
                <div
                  className={`absolute w-[7.2vw] h-[0.9vw]  top-[12.8vw] left-[3.2vw] outline-none rounded-[1.8vw]  ${
                    loadType_1
                      ? "bg-color-primary-D"
                      : suspensionPercent2 <= 10
                      ? `${loadType_1 ? "" : "animAlarm"}`
                      : "bg-color-primary-D"
                  } `}
                ></div>
                {!loadType_1 && suspensionPercent2 <= 10 ? (
                  <div className="absolute top-[15.5vw] left-0">
                    {SHOW_PIECES("suspension", "#FEC42B")}
                  </div>
                ) : (
                  <div className="absolute top-[15.5vw] left-0">
                    {SHOW_PIECES("suspension", "#00FFF2")}
                  </div>
                )}

                <div className="w-[44.95648687530954vw] h-[30.42616919412278vw]">
                  {!loadType_1 && suspensionPercent2 <= 10
                    ? SIGMENT_BOX_LEFT_YELLOW
                    : SIGMENT_BOX_LEFT_BLUE}
                </div>

                {!loadApiEnd && <BlueLoader width={10} top={33.5} right={22} />}

                <div
                  className={`absolute top-0 right-0 W-[30.42381075918021vw] h-[30.42381075918021vw]  ${
                    !loadApiEnd ? "hidden" : ""
                  }`}
                >
                  {sigments(suspensionPercent2)}
                </div>
                <div
                  className={`absolute w-[18.16329507799378vw] h-[18.16329507799378vw]  top-[20.5%] right-[14%] flex items-center justify-center rounded-full ${
                    !loadApiEnd ? "hidden" : ""
                  }`}
                >
                  <span
                    className={` text-[7.546991816230749vw] ${
                      suspensionPercent2 <= 10
                        ? "text-color-primary-B"
                        : "text-color-primary-D"
                    } font-font_primary_D `}
                  >
                    {suspensionPercent2 < 10
                      ? `0${suspensionPercent2}`
                      : `${suspensionPercent2}`}
                  </span>
                </div>
              </div>
              {/* /// suspension  section end /// */}
            </div>
            <div className="flex items-center justify-between px-[3.773495908115375vw] py-[0.5vw]">
              {/* /// belt  section start /// */}
              <div
                className="relative animFadeIn"
                onClick={(e) => {
                  navigate(`/piece-details/${beltPercent}_engine-straps`);
                }}
              >
                <span
                  className={`absolute ${
                    !loadType_4 && beltPercent2 <= 10
                      ? "text-color-primary-B"
                      : "text-color-primary-D"
                  } font-font_primary_A text-[2.8vw] top-[3.7vw] right-[2.5vw]`}
                >
                  {PIECES_TITLE["engine-straps"]}
                </span>
                <div
                  className={`absolute w-[7.2vw] h-[0.9vw]  top-[12.8vw] right-[3.2vw] outline-none rounded-[1.8vw]  ${
                    loadType_4
                      ? "bg-color-primary-D"
                      : beltPercent2 <= 10
                      ? `${loadType_4 ? "" : "animAlarm"}`
                      : "bg-color-primary-D"
                  } `}
                ></div>
                {!loadType_4 && beltPercent2 <= 10 ? (
                  <div className="absolute top-[15.5vw] right-0">
                    {SHOW_PIECES("engine-straps", "#FEC42B")}
                  </div>
                ) : (
                  <div className="absolute top-[15.5vw] right-0">
                    {SHOW_PIECES("engine-straps", "#00FFF2")}
                  </div>
                )}

                <div className="w-[44.95648687530954vw] h-[30.42616919412278vw]">
                  {!loadType_4 && beltPercent2 <= 10
                    ? SIGMENT_BOX_RIGHT_YELLOW
                    : SIGMENT_BOX_RIGHT_BLUE}
                </div>

                {!loadApiEnd && <BlueLoader width={10} top={33.5} left={23} />}

                <div
                  className={`absolute top-0 left-0 W-[30.42381075918021vw] h-[30.42381075918021vw]  ${
                    !loadApiEnd ? "hidden" : ""
                  }`}
                >
                  {sigments(beltPercent2)}
                </div>

                <div
                  className={`absolute w-[18.16329507799378vw] h-[18.16329507799378vw]  top-[20.5%] right-[46%] flex items-center justify-center rounded-full ${
                    !loadApiEnd ? "hidden" : ""
                  }`}
                >
                  <span
                    className={` text-[7.546991816230749vw] ${
                      beltPercent2 <= 10
                        ? "text-color-primary-B"
                        : "text-color-primary-D"
                    } font-font_primary_D `}
                  >
                    {beltPercent2 < 10 ? `0${beltPercent2}` : `${beltPercent2}`}
                  </span>
                </div>
              </div>
              {/* /// belt  section end /// */}

              {/* /// catalyst section start /// */}
              <div
                className="relative animFadeIn "
                onClick={(e) => {
                  navigate(`/piece-details/${catalystPercent}_catalyst`);
                }}
              >
                <span
                  className={`absolute ${
                    !loadType_3 && catalystPercent2 <= 10
                      ? "text-color-primary-B"
                      : "text-color-primary-D"
                  } font-font_primary_A text-[2.8vw] top-[3.5vw] left-[3vw]`}
                >
                  {PIECES_TITLE["catalyst"]}
                </span>
                <div
                  className={`absolute w-[7.2vw] h-[0.9vw]  top-[12.8vw] left-[3.2vw] outline-none rounded-[1.8vw]  ${
                    loadType_3
                      ? "bg-color-primary-D"
                      : catalystPercent2 <= 10
                      ? `${loadType_3 ? "" : "animAlarm"}`
                      : "bg-color-primary-D"
                  } `}
                ></div>
                {!loadType_3 && catalystPercent2 <= 10 ? (
                  <div className="absolute top-[15.5vw] left-0">
                    {SHOW_PIECES("catalyst", "#FEC42B")}
                  </div>
                ) : (
                  <div className="absolute top-[15.5vw] left-0">
                    {SHOW_PIECES("catalyst", "#00FFF2")}
                  </div>
                )}

                <div className="w-[44.95648687530954vw] h-[30.42616919412278vw]">
                  {!loadType_3 && catalystPercent2 <= 10
                    ? SIGMENT_BOX_LEFT_YELLOW
                    : SIGMENT_BOX_LEFT_BLUE}
                </div>

                {!loadApiEnd && <BlueLoader width={10} top={33.5} right={22} />}

                <div
                  className={`absolute top-0 right-0 W-[30.42381075918021vw] h-[30.42381075918021vw]  ${
                    !loadApiEnd ? "hidden" : ""
                  }`}
                >
                  {sigments(catalystPercent2)}
                </div>
                <div
                  className={`absolute w-[18.16329507799378vw] h-[18.16329507799378vw]  top-[20.5%] right-[14%] flex items-center justify-center rounded-full ${
                    !loadApiEnd ? "hidden" : ""
                  }`}
                >
                  <span
                    className={` text-[7.546991816230749vw] ${
                      catalystPercent2 <= 10
                        ? "text-color-primary-B"
                        : "text-color-primary-D"
                    } font-font_primary_D `}
                  >
                    {catalystPercent2 < 10
                      ? `0${catalystPercent2}`
                      : `${catalystPercent2}`}
                  </span>
                </div>
              </div>
              {/* /// catalyst section end /// */}
            </div>

            <div className="flex items-center justify-between px-[3.773495908115375vw] py-[0.5vw]">
              {/* /// cooler  section start /// */}
              <div
                className="relative animFadeIn"
                onClick={(e) => {
                  navigate(`/piece-details/${coolerPercent}_cooler`);
                }}
              >
                <span
                  className={`absolute ${
                    !loadType_5 && coolerPercent2 <= 10
                      ? "text-color-primary-B"
                      : "text-color-primary-D"
                  } font-font_primary_A text-[2.8vw] top-[3.7vw] right-[4vw]`}
                >
                  {PIECES_TITLE["cooler"]}
                </span>
                <div
                  className={`absolute w-[7.2vw] h-[0.9vw]  top-[12.8vw] right-[3.2vw] outline-none rounded-[1.8vw] ${
                    loadType_5
                      ? "bg-color-primary-D"
                      : coolerPercent2 <= 10
                      ? `${loadType_5 ? "" : "animAlarm"}`
                      : "bg-color-primary-D"
                  } `}
                ></div>
                {!loadType_5 && coolerPercent2 <= 10 ? (
                  <div className="absolute top-[15.5vw] right-0">
                    {SHOW_PIECES("cooler", "#FEC42B")}
                  </div>
                ) : (
                  <div className="absolute top-[15.5vw] right-0">
                    {SHOW_PIECES("cooler", "#00FFF2")}
                  </div>
                )}

                <div className="w-[44.95648687530954vw] h-[30.42616919412278vw]">
                  {!loadType_5 && coolerPercent2 <= 10
                    ? SIGMENT_BOX_RIGHT_YELLOW
                    : SIGMENT_BOX_RIGHT_BLUE}
                </div>

                {!loadApiEnd && <BlueLoader width={10} top={33.5} left={23} />}

                <div
                  className={`absolute top-0 left-0 W-[30.42381075918021vw] h-[30.42381075918021vw]  ${
                    !loadApiEnd ? "hidden" : ""
                  }`}
                >
                  {sigments(coolerPercent2)}
                </div>

                <div
                  className={`absolute w-[18.16329507799378vw] h-[18.16329507799378vw]  top-[20.5%] right-[46%] flex items-center justify-center rounded-full ${
                    !loadApiEnd ? "hidden" : ""
                  }`}
                >
                  <span
                    className={` text-[7.546991816230749vw] ${
                      coolerPercent2 <= 10
                        ? "text-color-primary-B"
                        : "text-color-primary-D"
                    } font-font_primary_D `}
                  >
                    {coolerPercent2 < 10
                      ? `0${coolerPercent2}`
                      : `${coolerPercent2}`}
                  </span>
                </div>
              </div>
              {/* /// cooler  section end /// */}
              {/* /// lighting  section strt /// */}
              <div
                className="relative animFadeIn"
                onClick={(e) => {
                  navigate(`/piece-details/${lightingPercent}_lamp`);
                }}
              >
                <span
                  className={`absolute ${
                    !loadType_8 && lightingPercent2 <= 10
                      ? "text-color-primary-B"
                      : "text-color-primary-D"
                  } font-font_primary_A text-[2.8vw] top-[3.5vw] left-[5.5vw]`}
                >
                  {PIECES_TITLE["lamp"]}
                </span>
                <div
                  className={`absolute w-[7.2vw] h-[0.9vw]  top-[12.8vw] left-[3.2vw] outline-none rounded-[1.8vw]  ${
                    loadType_8
                      ? "bg-color-primary-D"
                      : lightingPercent2 <= 10
                      ? `${loadType_8 ? "" : "animAlarm"}`
                      : "bg-color-primary-D"
                  } `}
                ></div>
                {!loadType_8 && lightingPercent2 <= 10 ? (
                  <div className="absolute top-[15.5vw] left-0">
                    {SHOW_PIECES("lamp", "#FEC42B")}
                  </div>
                ) : (
                  <div className="absolute top-[15.5vw] left-0">
                    {SHOW_PIECES("lamp", "#00FFF2")}
                  </div>
                )}

                <div className="w-[44.95648687530954vw] h-[30.42616919412278vw]">
                  {!loadType_8 && lightingPercent2 <= 10
                    ? SIGMENT_BOX_LEFT_YELLOW
                    : SIGMENT_BOX_LEFT_BLUE}
                </div>

                {!loadApiEnd && <BlueLoader width={10} top={33.5} right={22} />}

                <div
                  className={`absolute top-0 right-0 W-[30.42381075918021vw] h-[30.42381075918021vw]  ${
                    !loadApiEnd ? "hidden" : ""
                  }`}
                >
                  {sigments(lightingPercent2)}
                </div>
                <div
                  className={`absolute w-[18.16329507799378vw] h-[18.16329507799378vw]  top-[20.5%] right-[14%] flex items-center justify-center rounded-full ${
                    !loadApiEnd ? "hidden" : ""
                  }`}
                >
                  <span
                    className={` text-[7.546991816230749vw] ${
                      lightingPercent2 <= 10
                        ? "text-color-primary-B"
                        : "text-color-primary-D"
                    } font-font_primary_D `}
                  >
                    {lightingPercent2 < 10
                      ? `0${lightingPercent2}`
                      : `${lightingPercent2}`}
                  </span>
                </div>
              </div>
              {/* /// lighting  section end /// */}
            </div>
            <div className="flex items-center justify-between px-[3.773495908115375vw] pt-[0.5vw]">
              {/* /// detailing  section start /// */}
              <div
                className="relative animFadeIn"
                onClick={(e) => {
                  navigate(`/piece-details/${detailingPercent}_detailing`);
                }}
              >
                <span
                  className={`absolute ${
                    !loadType_6 && detailingPercent2 <= 10
                      ? "text-color-primary-B"
                      : "text-color-primary-D"
                  } font-font_primary_A text-[2.8vw] top-[3.7vw] right-[2.5vw]`}
                >
                  {PIECES_TITLE["detailing"]}
                </span>
                <div
                  className={`absolute w-[7.2vw] h-[0.9vw]  top-[12.8vw] right-[3.2vw] outline-none rounded-[1.8vw]  ${
                    loadType_6
                      ? "bg-color-primary-D"
                      : detailingPercent2 <= 10
                      ? `${loadType_6 ? "" : "animAlarm"}`
                      : "bg-color-primary-D"
                  } `}
                ></div>
                {!loadType_6 && detailingPercent2 <= 10 ? (
                  <div className="absolute top-[15.5vw] right-0">
                    {SHOW_PIECES("detailing", "#FEC42B")}
                  </div>
                ) : (
                  <div className="absolute top-[15.5vw] right-0">
                    {SHOW_PIECES("detailing", "#00FFF2")}
                  </div>
                )}

                <div className="w-[44.95648687530954vw] h-[30.42616919412278vw]">
                  {!loadType_6 && detailingPercent2 <= 10
                    ? SIGMENT_BOX_RIGHT_YELLOW
                    : SIGMENT_BOX_RIGHT_BLUE}
                </div>

                {!loadApiEnd && <BlueLoader width={10} top={33.5} left={23} />}

                <div
                  className={`absolute top-0 left-0 W-[30.42381075918021vw] h-[30.42381075918021vw]  ${
                    !loadApiEnd ? "hidden" : ""
                  }`}
                >
                  {sigments(detailingPercent2)}
                </div>

                <div
                  className={`absolute w-[18.16329507799378vw] h-[18.16329507799378vw]  top-[20.5%] right-[46%] flex items-center justify-center rounded-full ${
                    !loadApiEnd ? "hidden" : ""
                  }`}
                >
                  <span
                    className={` text-[7.546991816230749vw] ${
                      detailingPercent2 <= 10
                        ? "text-color-primary-B"
                        : "text-color-primary-D"
                    } font-font_primary_D `}
                  >
                    {detailingPercent2 < 10
                      ? `0${detailingPercent2}`
                      : `${detailingPercent2}`}
                  </span>
                </div>
              </div>
              {/* /// detailing  section end /// */}
              {/* /// pickling section strt /// */}
              <div
                className="relative animFadeIn"
                onClick={(e) => {
                  navigate(`/piece-details/${picklingPercent}_wrenching`);
                }}
              >
                <span
                  className={`absolute ${
                    !loadType_7 && picklingPercent2 <= 10
                      ? "text-color-primary-B"
                      : "text-color-primary-D"
                  } font-font_primary_A text-[2.8vw] top-[3.5vw] left-[3vw]`}
                >
                  {PIECES_TITLE["wrenching"]}
                </span>
                <div
                  className={`absolute w-[7.2vw] h-[0.9vw]  top-[12.8vw] left-[3.2vw] outline-none rounded-[1.8vw]  ${
                    loadType_7
                      ? "bg-color-primary-D"
                      : picklingPercent2 <= 10
                      ? `${loadType_7 ? "" : "animAlarm"}`
                      : "bg-color-primary-D"
                  } `}
                ></div>
                {!loadType_7 && picklingPercent2 <= 10 ? (
                  <div className="absolute top-[15.5vw] left-0">
                    {SHOW_PIECES("wrenching", "#FEC42B")}
                  </div>
                ) : (
                  <div className="absolute top-[15.5vw] left-0">
                    {SHOW_PIECES("wrenching", "#00FFF2")}
                  </div>
                )}

                <div className="w-[44.95648687530954vw] h-[30.42616919412278vw]">
                  {!loadType_7 && picklingPercent2 <= 10
                    ? SIGMENT_BOX_LEFT_YELLOW
                    : SIGMENT_BOX_LEFT_BLUE}
                </div>

                {!loadApiEnd && <BlueLoader width={10} top={33.5} right={22} />}

                <div
                  className={`absolute top-0 right-0 W-[30.42381075918021vw] h-[30.42381075918021vw]  ${
                    !loadApiEnd ? "hidden" : ""
                  }`}
                >
                  {sigments(picklingPercent2)}
                </div>
                <div
                  className={`absolute w-[18.16329507799378vw] h-[18.16329507799378vw]  top-[20.5%] right-[14%] flex items-center justify-center rounded-full ${
                    !loadApiEnd ? "hidden" : ""
                  }`}
                >
                  <span
                    className={` text-[7.546991816230749vw] ${
                      picklingPercent2 <= 10
                        ? "text-color-primary-B"
                        : "text-color-primary-D"
                    } font-font_primary_D `}
                  >
                    {picklingPercent2 < 10
                      ? `0${picklingPercent2}`
                      : `${picklingPercent2}`}
                  </span>
                </div>
              </div>
              {/* /// pickling section end /// */}
            </div>
          </div>
        </div>

        <Footer forwardRef={footerRef} />
      </div>
    </>
  );
}
